module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_2-f8402a85c9047ac735af1f150c641397.jpg";